import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 0 512 512" className={className} {...size}>
    <path
      d="M256.5 256H6.7c-4 4.5-6.1 10.4-5.7 16.4 5.1 80 47.4 152.6 113.6 196.7 4.8 3.2 10.9 4.5 17 3.3L256.5 256zM131.6 39.7c-5.9-1.2-12 0-17 3.3C48.5 87.1 6.1 159.6 1 239.6c-.4 6 1.7 11.9 5.7 16.4h249.8L131.6 39.7z"
      fill="#ffa000"
    />
    <path
      d="M381.4 39.7c-1.9-5.7-5.9-10.4-11.3-13.1-71.4-35.4-155.8-35.5-227.3 0-5.3 2.6-9.4 7.4-11.3 13.1l125 216.3L381.4 39.7zM131.6 472.3c1.9 5.7 5.9 10.4 11.3 13.1 71.4 35.4 155.8 35.5 227.3 0 11.6-5.7 15.8-20.2 9.4-31.3l-110-190.6-13-7.5-125 216.3z"
      fill="#ffa000"
    />
    <path
      d="M511.9 239.6c-5-80-47.4-152.6-113.6-196.7-5-3.3-11.1-4.5-17-3.3L256.5 256l13 7.5h220c12.9 0 23.3-11 22.4-23.9z"
      fill="#ffa000"
    />
    <path
      d="M204.9 256L91.8 451.9c7.3 6.1 14.9 11.9 22.8 17.1 4.8 3.2 10.9 4.5 17 3.3L256.5 256h-51.6zM131.6 39.7c-5.9-1.2-12 0-17 3.3-2.3 1.5-4.6 3.1-6.8 4.7L216.5 236H1.3l-.3 3.6c-.4 6 1.7 11.9 5.7 16.4h249.8L131.6 39.7z"
      fill="#f57c00"
    />
    <path
      d="M370.1 26.6c-10.4-5.2-21.1-9.6-32-13.3 1.4 1.9 2.5 4.1 3.3 6.3L230.7 211.4l25.8 44.6L381.4 39.7c-1.9-5.7-5.9-10.5-11.3-13.1zM379.5 454.1l-110-190.6-13-7.5-9.9 17.1L339.5 434c6.5 11.2 2.2 25.6-9.4 31.3-63.1 31.3-134.1 33.9-195.2 13.3 2.1 2.8 4.8 5.2 8 6.7C178.4 503 216.6 512 256.5 512s78.1-8.9 113.6-26.6c11.6-5.7 15.9-20.2 9.4-31.3z"
      fill="#f57c00"
    />
    <path
      d="M511.9 239.6c-5-80-47.4-152.6-113.6-196.7-5-3.3-11.1-4.5-17-3.3l-.2.4c54.1 45.6 86.4 110.4 90.8 179.6.8 12.9-9.5 23.9-22.5 23.9H263.7l-7.2 12.5 13 7.5h220c12.9 0 23.3-11 22.4-23.9z"
      fill="#f57c00"
    />
    <path
      d="M49.2 256c0 12.4-2.9 24.9-.8 36.7 2.1 12.1 9.1 22.9 13.3 34.2 4.2 11.5 5.8 24.3 11.8 34.7 6.1 10.6 16.4 18.3 24.2 27.6 7.8 9.3 13.7 20.8 23 28.6 9.3 7.8 21.6 11.6 32.1 17.7L256.5 256H49.2z"
      fill="#ffe082"
    />
    <path
      d="M204.9 256l-90.1 156c1.8 2.1 3.7 4 5.8 5.8 9.3 7.8 21.6 11.6 32.1 17.7L256.5 256h-51.6z"
      fill="#ffca28"
    />
    <path
      d="M152.8 435.5c10.4 6 19.8 14.9 31.4 19.1 11.3 4.1 24.1 3.4 36.3 5.6 11.8 2.1 23.6 7.1 36 7.1 12.4 0 24.2-5 36-7.1 12.1-2.1 24.9-1.4 36.3-5.6 5.7-2.1 10.9-5.3 15.9-8.7 8.7-5.9 11.4-17.5 6.1-26.6-25.5-44.1-94.3-163.3-94.3-163.3L152.8 435.5z"
      fill="#ffe082"
    />
    <path
      d="M256.5 256l-14.2 24.6 77.9 134.9c-13.1 8.1-20.7 15.1-31.4 19.1-11.3 4.1-24.1 3.4-36.3 5.6-11.8 2.1-23.6 7.1-36 7.1s-24.2-5.1-36-7.1c-8.1-1.4-16.6-1.6-24.6-2.8 9.3 5.9 17.9 13.4 28.4 17.2 11.3 4.1 24.1 3.4 36.3 5.6 11.8 2.1 23.6 7.1 36 7.1 12.4 0 24.2-5 36-7.1 12.1-2.1 24.9-1.5 36.3-5.6 5.7-2.1 10.9-5.3 15.9-8.7 8.7-5.9 11.4-17.5 6.1-26.6-25.6-44.1-94.4-163.3-94.4-163.3z"
      fill="#ffca28"
    />
    <path
      d="M152.8 76.5c-10.6 6.1-22.8 9.9-32.1 17.7-9.3 7.8-15.1 19.3-23 28.6-7.8 9.3-18.1 17-24.2 27.6-6.1 10.5-7.6 23.2-11.8 34.7-4.1 11.3-11.1 22.1-13.3 34.2-2.1 11.8.8 24.3.8 36.7h207.3L152.8 76.5z"
      fill="#ffe082"
    />
    <path
      d="M152.8 76.5c-7.1 4.1-14.9 7.1-22.1 11L199.2 206c7.7 13.3-1.9 30-17.3 30h-134c.5 6.6 1.3 13.3 1.3 20h207.3L152.8 76.5z"
      fill="#ffca28"
    />
    <path
      d="M328.8 57.4c-11.3-4.1-24.1-3.4-36.3-5.6-11.8-2.1-23.6-7.1-36-7.1-12.4 0-24.2 5-36 7.1-12.1 2.1-24.9 1.4-36.3 5.6-11.5 4.2-20.9 13-31.4 19L256.5 256 360.1 76.5c-10.4-6.1-19.8-14.9-31.3-19.1z"
      fill="#ffe082"
    />
    <path
      d="M360.1 76.5c-10.5-6.1-19.8-14.9-31.4-19-2.6-.9-5.2-1.6-7.9-2.1l-90.1 156.1 25.8 44.6L360.1 76.5z"
      fill="#ffca28"
    />
    <path
      d="M448.6 256c8.3 0 15.3-6.4 16-14.7.6-7.5 1.2-14.8 0-22-2.1-12.1-9.1-22.9-13.3-34.2-4.2-11.5-5.8-24.3-11.8-34.7-6.1-10.6-16.4-18.3-24.2-27.6-7.8-9.3-13.7-20.8-23-28.6-9.3-7.8-21.6-11.6-32.1-17.7L256.5 256h101v50.1c0 10.2 8.3 18.5 18.5 18.5 11.8 0 19.7-9.1 19.7-19.1v-6.9c0-6.6 5.3-11.9 11.9-11.9s11.9 5.3 11.9 11.9V352c0 8 6.5 14.6 14.6 14.6 8 0 14.6-6.5 14.6-14.6v-96z"
      fill="#ffe082"
    />
    <path
      d="M464.6 219.3c-2.1-12.1-9.1-22.9-13.3-34.2-4.2-11.5-5.8-24.3-11.8-34.7-6.1-10.6-16.4-18.3-24.2-27.6-7.8-9.3-13.7-20.8-23-28.6-9.3-7.8-21.6-11.6-32.1-17.7l-2 3.5c6.2 7.1 11.1 15.6 17.1 22.8 7.8 9.3 18.1 17 24.2 27.6 6.1 10.5 7.6 23.2 11.8 34.7 4.1 11.3 11.1 22.1 13.3 34.2 0 .1 0 .2.1.4 3.2 19.1-11.8 36.3-31.2 36.3H268l-11.5 20h152.1v30.8c6.1.5 10.9 5.6 10.9 11.8v53.5c0 8 6.5 14.6 14.6 14.6 8 0 14.6-6.5 14.6-14.6V256c8.3 0 15.3-6.4 16-14.7.6-7.5 1.1-14.9-.1-22z"
      fill="#ffca28"
    />
    <path
      d="M263.9 400.1c0 16.4-13.3 29.7-29.7 29.7s-29.7-13.3-29.7-29.7 13.3-29.7 29.7-29.7 29.7 13.3 29.7 29.7zM171.2 353c0 16.4-13.3 29.7-29.7 29.7s-29.7-13.3-29.7-29.7 13.3-29.7 29.7-29.7 29.7 13.3 29.7 29.7zM195.7 199.9c0 16.4-13.3 29.7-29.7 29.7s-29.7-13.3-29.7-29.7 13.3-29.7 29.7-29.7c16.4-.1 29.7 13.2 29.7 29.7zM258.1 99.1c0 16.4-13.3 29.7-29.7 29.7s-29.7-13.3-29.7-29.7 13.3-29.7 29.7-29.7 29.7 13.3 29.7 29.7z"
      fill="#ef5350"
    />
    <g fill="#ff6f00">
      <path d="M388.7 135.9c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zM340.8 213.1c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9c8.3.1 14.9 6.7 14.9 14.9zM323.4 91.3c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9c8.3.1 14.9 6.7 14.9 14.9zM271.4 173.6c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zM104.8 219.1c0 8.2-6.7 14.9-14.9 14.9S75 227.3 75 219.1s6.7-14.9 14.9-14.9c8.3.1 14.9 6.7 14.9 14.9zM190.2 289.6c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9c8.2.1 14.9 6.7 14.9 14.9zM155.8 124.7c-2.3-7.9-10.6-12.4-18.4-10.1-7.9 2.3-12.4 10.6-10.1 18.4 2.3 7.9 10.6 12.4 18.4 10.1 7.8-2.3 12.4-10.5 10.1-18.4zM110.2 300.6c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zM319.5 415c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zM271.4 330.3c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9z" />
    </g>
    <path
      d="M428.8 201.9c0 16.4-13.3 29.7-29.7 29.7s-29.7-13.3-29.7-29.7 13.3-29.7 29.7-29.7c16.4-.1 29.7 13.2 29.7 29.7z"
      fill="#ef5350"
    />
    <path
      d="M240.4 371c2.3 4.2 3.5 9 3.5 14.1 0 18.9-17.4 33-35.9 29.1 5 9.3 14.9 15.6 26.2 15.6 16.4 0 29.7-13.3 29.7-29.7 0-14.3-10.1-26.2-23.5-29.1zM147.7 323.9c2.3 4.2 3.5 9 3.5 14.1 0 16.4-13.3 29.7-29.7 29.7-2.1 0-4.2-.2-6.2-.6 5 9.3 14.9 15.6 26.2 15.6 16.4 0 29.7-13.3 29.7-29.7 0-14.3-10.1-26.3-23.5-29.1zM172.2 170.8c2.3 4.2 3.5 9 3.5 14.1 0 16.4-13.3 29.7-29.7 29.7-2.1 0-4.2-.2-6.2-.6 5 9.3 14.9 15.6 26.2 15.6 16.4 0 29.7-13.3 29.7-29.7 0-14.3-10.1-26.3-23.5-29.1zM234.6 70.1c2.3 4.2 3.5 9 3.5 14.1 0 16.4-13.3 29.7-29.7 29.7-2.1 0-4.2-.2-6.2-.6 5 9.3 14.9 15.6 26.2 15.6 16.4 0 29.7-13.3 29.7-29.7 0-14.4-10.1-26.3-23.5-29.1zM405.3 172.8c2.3 4.2 3.5 9 3.5 14.1 0 16.4-13.3 29.7-29.7 29.7-2.1 0-4.2-.2-6.2-.6 5 9.3 14.9 15.6 26.2 15.6 16.4 0 29.7-13.3 29.7-29.7 0-14.3-10.1-26.3-23.5-29.1z"
      fill="#d32f2f"
    />
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
